import { styled } from "@mui/material/styles";
import { Box, TextField } from "@mui/material";

export const VerificationCodeContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "8px",
  marginBottom: "16px",
}));

export const VerificationCodeField = styled(TextField)(({ theme }) => ({
  width: "60px",

  "& .MuiOutlinedInput-root": {
    height: "70px",
    borderRadius: "8px",
    border: `1px solid ${theme.palette.border.medium}`,
    backgroundColor: theme.palette.background.secondary,

    "& fieldset": {
      border: "none",
    },

    "&:hover fieldset": {
      border: "none",
    },

    "&.Mui-focused fieldset": {
      border: `1px solid ${theme.palette.primary.main}`,
    },

    "&.Mui-error fieldset": {
      border: "1px solid #F44336",
    },
  },

  "& .MuiInputBase-input": {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: 600,
    color: "#1B252F",
    padding: "12px",

    "&::placeholder": {
      color: theme.palette.border.medium,
      opacity: 1,
    },
  },

  // Empty input styles - when value is empty string
  "&.empty-input .MuiInputBase-input": {
    color: theme.palette.border.medium,
  },

  "&.empty-input .MuiOutlinedInput-root": {
    border: `1px solid ${theme.palette.border.medium}`,
  },
}));

export const VerificationCodeDivider = styled(Box)(({ theme }) => ({
  width: "30px",
  height: "2px",
  backgroundColor: theme.palette.border.medium,
  alignSelf: "center",
  borderRadius: "50px",
  margin: "0 8px",
}));
